import * as React from 'react'

import { AttendanceEmployeeRoutesDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import { buildModuleRoute, buildNavigation } from 'modules/core/lib/react-router'

import { AttendanceDateNavigatorProvider } from 'modules/attendance/lib/attendanceDateNavigatorContext'
import { AttendanceFeaturesProvider } from 'modules/attendance/lib/attendanceFeaturesContext'

const EmployeePeriodEditOvertimeRequestPage = React.lazy(
  () => import('modules/attendance/pages/EmployeePeriodEditOvertimeRequestPage')
)

const EmployeePeriodExportsModalPage = React.lazy(
  () => import('modules/attendance/pages/EmployeePeriodExportsModalPage')
)

const EmployeePeriodNewOvertimeRequestPage = React.lazy(
  () => import('modules/attendance/pages/EmployeePeriodNewOvertimeRequestPage')
)

const EmployeePeriodRootPage = React.lazy(
  () => import('modules/attendance/pages/EmployeePeriodRootPage')
)
const EmployeeRootPage = React.lazy(() => import('modules/attendance/pages/EmployeeRootPage'))
const NavigateToPeriodPage = React.lazy(
  () => import('modules/attendance/pages/NavigateToPeriodPage')
)

const BreakdownSidepanelPage = React.lazy(() => import('modules/attendance/pages/SidepanelPage'))

export const clockInRoutes = buildNavigation((navigation) => [
  buildModuleRoute({
    path: navigation.clockIn.path,
    handle: {
      module: 'clock-in',
      moduleName: () => i18n.t('clock_in.header.title'),
      meta: ({ watchQuery, session }) => {
        const metaObject = {
          title: i18n.t('clock_in.header.title'),
        }
        if (!session.employee) return metaObject
        return watchQuery({
          query: AttendanceEmployeeRoutesDocument,
          variables: {
            employeeId: session.employee.id,
            skipFetchingSettings: false,
          },
        }).map(({ data }) => {
          let route: string | undefined
          const accessEditSettings = data.attendance._policies.accessEditSettings.can
          const attendanceSettingId = data?.attendance?.employeesSettingsConnection?.nodes?.[0]?.id
          if (accessEditSettings && attendanceSettingId) {
            const routeParams = {
              id: 'time_tracking',
              settingId: attendanceSettingId.toString() ?? 'default',
              tabId: 'edit',
            }
            route = navigation.settings.time_tracking.settingId.tabId.fullPath(routeParams)
          }
          return {
            ...metaObject,
            settings: route,
          }
        })
      },
    },
    element: (
      <AttendanceFeaturesProvider>
        <AttendanceDateNavigatorProvider>
          <EmployeeRootPage />
        </AttendanceDateNavigatorProvider>
      </AttendanceFeaturesProvider>
    ),

    children: [
      {
        index: true,
        element: <NavigateToPeriodPage />,
      },
      {
        path: navigation.clockIn.periodTypeYearMonthDay.path,
        element: <EmployeePeriodRootPage />,
        children: [
          {
            path: navigation.clockIn.periodTypeYearMonthDay.exportsEmployeeId.path,
            element: <EmployeePeriodExportsModalPage />,
          },
          {
            path: navigation.clockIn.periodTypeYearMonthDay.requestOvertimeEmployeeId.path,
            element: <EmployeePeriodNewOvertimeRequestPage />,
          },
          {
            path: navigation.clockIn.periodTypeYearMonthDay.overtimeRequestEmployeeId.path,
            element: <EmployeePeriodEditOvertimeRequestPage />,
          },
          {
            path: navigation.clockIn.periodTypeYearMonthDay.workedHoursBreakdownEmployeeId.path,
            element: <BreakdownSidepanelPage tabFromNavigation="worked_hours" />,
          },
          {
            path: navigation.clockIn.periodTypeYearMonthDay.balanceBreakdownEmployeeId.path,
            element: <BreakdownSidepanelPage tabFromNavigation="balance" />,
          },
          {
            path: navigation.clockIn.periodTypeYearMonthDay.compensationBreakdownEmployeeId.path,
            element: <BreakdownSidepanelPage tabFromNavigation="compensation" />,
          },
          {
            path: navigation.clockIn.periodTypeYearMonthDay.bankOfHoursEmployeeId.path,
            element: <BreakdownSidepanelPage tabFromNavigation="bank_of_hours" />,
          },
        ],
      },
    ],
  }),
])
